<template>
  <Message
    v-if="showBanner"
    severity="warn"
    :closable="false"
    class="mt-2"
    data-cy="existing-motor-shroud-banner"
  >
    <div
      class="container flex align-items-center justify-content-center flex-wrap"
    >
      A new shroud has been selected using the existing motor shroud interior
      diameter value. Please verify this is correct and click Resolve then save
      the scenario.
      <Button
        label="Resolve"
        class="p-button-sm p-button-outlined p-button-success ml-3"
        data-cy="existing-motor-shroud-banner-resolve"
        @click="resolveShroudDiameter"
      />
    </div>
  </Message>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Message from "primevue/message";
import Button from "primevue/button";
import { injectStrict } from "@/utils/utils";
import {
  equipmentKey,
  parametersFormKey,
  parametersKey
} from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { valuesExist } from "@/composables/validation/scenarioValidator";

const equipment = injectStrict(equipmentKey);
const parameters = injectStrict(parametersKey);
const parametersForm = injectStrict(parametersFormKey);

const showBanner = computed(
  () =>
    valuesExist([equipment.value?.r_shroud?.interior_diameter_inches]) &&
    (parameters.value?.motor_shroud_interior_diameter_inches ?? 0) > 0
);

const resolveShroudDiameter = () => {
  parametersForm.update({
    motor_shroud_interior_diameter_inches: null
  });
};
</script>
